//=================================\\
// Header Menu Settings \\
//=================================\\

export default function headerToggle() {
	let menuBtn = document.querySelector(".nav-primary__toggle-btn");
	menuBtn.addEventListener("click", () => menuBtn.classList.toggle("ac-open"));
	$(window).resize(function () {
		if ($(window).width() >= 640) {
			$(".nav-primary__mobail-menu-container").hide();

			if ($(".nav-primary__toggle-btn").hasClass("ac-open")) {
				let socialLinks = $('.ac-social-links');
				socialLinks.hide();
				$(".nav-primary__toggle-btn").removeClass("ac-open")
			}
		}
	});
}




// WEBPACK FOOTER //
// ./scripts/modules/ac-header-menu-toggle.js